module.exports = __webpack_public_path__ + "img/M.81de686c.png";